function delay(miliseconds: number) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, miliseconds);
  });
}

export { delay };
